import * as React from 'react';
import * as _ from 'lodash-es';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { ReduxState } from 'reducers/types';
import {
  get as getTravelers,
  emptyResults as emptyTravelers,
  Params,
} from 'actions/Travelers/Get';
import { emptyTraveler } from 'actions/Travelers/GetSingle';
import { getSingle as getUser } from 'actions/Users/GetSingle';
import { get as getCreditCards } from 'actions/User/GetUserCreditCards';
import UserDetails from 'components/UserDetails/UserDetail';
import { hasPermission } from 'helpers/Permission';
import { PermissionTypes } from '../../constants';

type Props = any;
class PageUserDetails extends React.Component<Props, any> {
  userId = this.props.params?.userId;

  componentDidMount() {
    const params: Params = {
      userId: this.userId,
    };

    this.props.getUser(this.userId, this.props.navigate);
    if (hasPermission('travelers', PermissionTypes.read)) {
      this.props.getTravelers(params);
    }
    this.props.emptyTraveler();
    if (hasPermission('creditCards', PermissionTypes.read)) {
      this.props.getCreditCards(this.userId);
    }
  }

  componentWillUnmount() {
    this.props.emptyTravelers();
  }

  render() {
    return (
      <UserDetails
        userId={_.get(this, 'userId', null)}
        travelerId={_.get(this.props, 'location.state.travelerId', null)} // if coming from Lookup Traveler / travelerId needed for traveler dropdown pre selection
      />
    );
  }
}

// Wire up redux state to component
function mapStateToProps(state: ReduxState) {
  return {};
}

// Wire up redux dispatch functions
function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getTravelers,
      getUser,
      emptyTraveler,
      getCreditCards,
      emptyTravelers,
    },
    dispatch,
  );
}

// Connect it to Redux
export default connectWithRouter(mapStateToProps, mapDispatchToProps)(PageUserDetails);
